module.exports = __webpack_public_path__ + "img/Dai4-3p-re1.4f37b4b9.png";